/**
 * The Settings section's paths, apart from its screen - the `debug-slugs.ts`
 * shape, for the same reason: `App.tsx` redirects a bare `/settings` to the
 * first of them without importing `Settings.tsx` into the entry chunk, and
 * `Settings.tsx` builds its tabs FROM this list (a record keyed by
 * `SettingsSlug`), so a slug with no tab is a typecheck failure.
 *
 * In order of importance, which is the strip's order: what the platform sells,
 * who carries it, the counters that ring for it, who is told about it, and the
 * numbers a guest calls. The first is what an unqualified `/settings` opens on.
 */
export const SETTINGS_SLUGS = ['ordering', 'delivery', 'counters', 'whatsapp', 'support'] as const;

export type SettingsSlug = (typeof SETTINGS_SLUGS)[number];
